import React, { Component } from 'react';
import { connect } from 'react-redux';
import { findCredit, cancelCredit, deleteCredit } from '../actions/credit';
import { findSub } from '../actions/subs';
import { findAttSub } from '../actions/attSubs';
import { findTracfoneSub } from '../actions/tracfoneSubs';
import { findSimoSub } from '../actions/simoSubs';
import { findQuickSub } from '../actions/quickSubs';
import { findUser } from '../actions/users';
import withCredit from './withCredit';
import { getIsAdmin } from '../reducers';
import { transformErrorResponse } from '../helpers/errors';

const creditPage = (DecoratedComponent) => {
  class CreditPage extends Component {
    state = {
      error: undefined,
      success: '',
    };

    componentDidMount() {
      this.fetchCredit();
    }

    componentDidUpdate(oldProps) {
      if (this.props.creditId !== oldProps.creditId) {
        this.fetchCredit();
      }

      if (this.props.subId && this.props.subId !== oldProps.subId) {
        this.fetchSub();
      }

      if (this.props.userId && this.props.userId !== oldProps.userId) {
        this.findUser(this.props.userId);
      }
    }

    fetchCredit() {
      const { findCredit, creditId } = this.props;
      findCredit(creditId);
    }

    fetchSub() {
      const {
        carrier,
        subId,
        findSub,
        findAttSub,
        findTracfoneSub,
        findSimoSub,
        findQuickSub,
      } = this.props;
      if (carrier && carrier === 'sprint') {
        findSub(subId);
      } else if (carrier && carrier === 'att') {
        findAttSub(subId);
      } else if (carrier && carrier === 'tracfone') {
        findTracfoneSub(subId);
      } else if (carrier && carrier === 'simo') {
        findSimoSub(subId);
      } else if (carrier && carrier === 'quick') {
        findQuickSub(subId);
      }
    }

    findUser = (id) => {
      if (id) {
        this.props.findUser(id);
      }
    };

    cancelCredit = () => {
      const { cancelCredit, creditId, credit } = this.props;
      cancelCredit(creditId)
        .then(() => this.goToCredits(credit.user_profile))
        .catch(this.handleCancelOrDeleteError);
    };

    deleteCredit = () => {
      const { deleteCredit, creditId, credit } = this.props;
      deleteCredit(creditId)
        .then(() => this.goToCredits(credit.user_profile))
        .catch(this.handleCancelOrDeleteError);
    };

    goToCredits = (userId) => {
      this.setState({ success: 'Success', error: undefined });
      setTimeout(() => {
        const { history } = this.props;
        history.push(`/users/${userId}/credits`);
      }, 3000);
    };

    handleCancelOrDeleteError = (err) => {
      if (err) {
        const error = transformErrorResponse(err);
        this.setState({
          error,
        });
      }
    };

    render() {
      const { children, ...props } = this.props;
      const { error, success } = this.state;

      const childrenProps = {
        ...props,
        deleteCredit: this.deleteCredit,
        cancelCredit: this.cancelCredit,
        error,
        success,
      };
      return React.createElement(DecoratedComponent, childrenProps, children);
    }
  }

  const mapStateToProps = (state) => ({
    isAdmin: getIsAdmin(state),
  });

  const mapDispatchToProps = {
    findCredit,
    cancelCredit,
    deleteCredit,
    findUser,
    findSub,
    findAttSub,
    findTracfoneSub,
    findSimoSub,
    findQuickSub,
  };

  CreditPage = withCredit(
    connect(mapStateToProps, mapDispatchToProps)(CreditPage),
  );

  return CreditPage;
};

export default creditPage;
